var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Ошибка 404 - Страница не найдена!")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Перейти на главную.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }